import React, { useState, useEffect } from "react";
import { sendGetRequestApi } from "../../services/service";
import { Row, Col, CardBody, Input, Badge, Button } from "reactstrap";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
// import Pagination from "../../components/Common/Pagination"
import { Link } from "react-router-dom";
// import QuestionMasterOffCanvas from "../../components/questionMaster/QuestionMasterOffCanvas";
import CustomTable from "../../common/CustomTable";
import { log_debug } from "../../helpers/logger";
import McqOffCanvas from "../../components/questionMaster/McqOffCanvas";
import TableLoader from "../../components/Common/TableLoader";
import { getCoding } from "../../store/api/getApi/getApiSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";

function CodingQuestions() {
  // const addTodo=useSelector(state=>state.todos)

  // const [copyData, setCopyData] = useState([])
  // const [copied, setCopied] = useState(false)
  const dispatch = useDispatch();
  const getApiStore = useSelector((state) => state.getApi);
  const [questionmaster, setQuestion_master] = useState(null);
  const [isPreloader, setIsPreloader] = useState(false);
  const [gu_id, setGu_id] = useState("");
  const [isRight, setIsRight] = useState(false);
  const [searchedWord, setSearchedWord] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [difficulty, setDifficulty] = useState("");
  const [status, setStatus] = useState("");

  const columns = [
    {
      Header: "Title ",
      accessor: "title",
      Cell: ({ row }) => (
        <Link
          to="#"
          style={{ cursor: "pointer", textDecoration: "underline" }}
          onClick={() => toggleRightCanvas(row.original)}
        >
          {row.original.question}
        </Link>
      ),
    },
    // {
    //   Header: "Category",
    //   accessor: "category",
    // },
    // {
    //   Header: "Skills",
    //   accessor: "skillTags",
    //   Cell: ({ row }) =>
    //     row.original.skillTags && row.original.skillTags.length > 0 && (
    //       // <ul style={{ padding: '1rem' }}>
    //       <>
    //         {" "}
    //         {row.original.skillTags.map((skill, index) => (
    //           <span key={index} className="bg-success badge me-1 bg-primary">
    //             {skill}
    //           </span>
    //         ))}
    //       </>
    //     ),
    // },
    {
      Header: "Difficulty",
      accessor: "difficultyLevel",
      Cell: ({ row }) => (
        <>
          <span
            className={`badge me-1 ${row.original.difficultyLevel === "easy" ? "bg-success" : row.original.difficultyLevel === "medium" ? "bg-warning" : "bg-danger"}`}
          >
            {row.original.difficultyLevel}
          </span>
        </>
      ),
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ row }) => (
        <>
          <div>
            <span
              className={`badge ${row.original.status === "draft" ? "bg-warning" : row.original.status === "active" ? "bg-success" : "bg-danger"}`}
            >
              {row.original.status}
            </span>
          </div>
        </>
      ),
    },
    {
      Header: "Actions",
      accessor: "edit",
      Cell: ({ row }) => (
        <>
          <div className="text-center">
            <Button
              color="primary"
              onClick={() => toggleRightCanvas(row.original)}
            >
              <i className="mdi mdi-eye" />
            </Button>
          </div>
        </>
      ),
    },
  ];
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    if(newPage === 0){
      dispatch(
        getCoding({
          currentPage: newPage,
          difficulty: difficulty,
          questionstatus: status,
          searchedWord: searchedWord,
        })
      );
    }
  };

  useEffect(() => {
    if (currentPage || difficulty || status || searchedWord || searchedWord === "") {
      const timer = setTimeout(() => {
        dispatch(
          getCoding({
            currentPage: currentPage,
            difficulty: difficulty,
            questionstatus: status,
            searchedWord: searchedWord,
          })
        );
      }, 700);

      return () => clearTimeout(timer);
    }
  }, [currentPage, difficulty, status, searchedWord]);

  useEffect(() => {
    setIsPreloader(true);
    if (getApiStore.status === "idle") {
      setIsPreloader(false);
      if (getApiStore?.data?.codingData?.success === true) {
        setQuestion_master(getApiStore?.data?.codingData?.data);
        setTotalCount(getApiStore?.data?.codingData?.pagination?.totalCodingQue);
      } else {
        // Check if user is still authenticated before dispatching API request
        const sessionToken = localStorage.getItem("sessionToken");

        if (sessionToken) {
          dispatch(
            getCoding({
              currentPage: currentPage,
              difficulty: difficulty,
              questionstatus: status,
              searchedWord: searchedWord,
            })
          );
        }
      }
    }
    setIsPreloader(false)
  }, [
    getApiStore?.data?.codingData
  ]);

  function handleSearchedVal(event) {
    SearchedValue = event.target.value;
  }

  function toggleRightCanvas(id) {
    setGu_id(id);
    setIsRight(!isRight);
  }
  const handleSearchOnEnter = (event) => {
    if (event.key === "Enter") {
      handleClick();
    }
  };

  const handleFilter = (value) => {
    log_debug("handlefilter", "mcqtable", JSON.stringify(value));
    if (value?.name === "difficulty") {
      setDifficulty(value?.value);
    } else if (value?.name === "status") {
      setStatus(value?.value);
    } else if (value?.name === "globalFilter") {
      setSearchedWord(value?.value);
    }
  };

  const handleToast = (status) => {
      if(status?.status === "Record deleted successfully"){
        toast.success(status?.status)
        setIsRight(false);
      }
    }

    useEffect(() => {
      return () => {
        document.body.style.overflow = "auto";
        document.body.style.paddingRight = "0px"; // Reset padding
      };
    }, [isRight]);

  //meta title
  // document.title = "Responsive Table | Minia - React Admin & Dashboard Template";

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Question Corpus" />
          <Row>
            <Col>
              <CardBody>
                <div className="table-rep-plugin">
                  <div className=" mb-0" data-pattern="priority-columns">
                    {questionmaster ? <CustomTable
                      currentPage={currentPage}
                      onPageChange={handlePageChange}
                      data={questionmaster}
                      columns={columns}
                      totalCount={totalCount}
                      showFilters={true}
                      onFilterChange={handleFilter}
                      isloading={!isPreloader}
                    /> : <TableLoader/>}
                  </div>
                </div>
              </CardBody>
            </Col>
          </Row>
          {isRight && (
            <McqOffCanvas
              type={"coding"}
              isOpen={isRight}
              toggleRightCanvas={toggleRightCanvas}
              mcqData={gu_id}
              handleToast = {handleToast}
            />
          )}
        </div>
      </div>
      <ToastContainer/>
    </React.Fragment>
  );
}

export default CodingQuestions;
